import React from "react";
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">
          <img src={require('../assets/logo_cloud_service.png')} alt="IGEL Cloud Services" />
        </div>
        <div className="footer-text">
          <p className="copyright">Copyright © 2025 IGEL, All Rights Reserved</p>
          <p className="version">Version: {process.env.REACT_APP_VERSION || '1.0.1'}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
